(function () {
  const faqBlocks = document.querySelectorAll(".faq-section-block_container");

  faqBlocks.forEach((block, index) => {
    const questionBtn = block.querySelector(".faq-section-block_question");
    const answer = block.querySelector(".faq-section-block_answer");

    // Default state
    if (index === 0) {
      block.classList.add("open", "open-answer");
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = "0px";
    }

    questionBtn.addEventListener("click", () => {
      // Close all FAQs
      faqBlocks.forEach((otherBlock) => {
        const otherAnswer = otherBlock.querySelector(".faq-section-block_answer");
        otherBlock.classList.remove("open", "open-answer");
        otherAnswer.style.maxHeight = "0px";
      });

      // Open clicked FAQ
      block.classList.add("open", "open-answer");
      answer.style.maxHeight = answer.scrollHeight + "px";
    });
  });
})();
